import { getGlobal } from "@RHCommerceDev/utils-globals/getGlobal";
import { hasLocale } from "@RHCommerceDev/utils/intlUtils";

const env = getGlobal("_env");

const IS_SERVER = typeof window === "undefined";

const getAbsoluteUrl = (path: string, locale: string) => {
  const origin = IS_SERVER
    ? `https://${env.ENV_DOMAIN}`
    : window.location.origin;

  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  if (hasLocale(path)) {
    return `${origin}${path}`;
  }

  return `${origin}${locale}${path}`;
};

export default getAbsoluteUrl;
